var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumericallyAsce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22l6-8h-4v-12h-4v12h-4l6 8zm13.936-6.323c.929-.998 3.024-1.006 3.737.691.212.503.319 1.217.327 1.944.008.774-.098 1.563-.313 2.129-.398 1.04-1.125 1.559-2.186 1.559-1.005 0-1.938-.605-2.056-1.758h1.32c.062.392.339.67.795.67.904 0 1.06-1.002 1.104-1.893-.63.79-1.915.743-2.73.016-.869-.774-.807-2.488.002-3.358zm2.23 2.677c.599-.383.547-1.452.184-1.907-.336-.42-.963-.421-1.314-.144-.512.399-.466 1.505-.137 1.909.269.331.866.404 1.267.142zm-4.166-12.879v-1.498c.565-.025 3.163.046 3.163-1.977h1.837v11h-2.255v-7.525h-2.745z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumericallyAsce);
export default __webpack_public_path__ + "static/media/numerically-asce.1db76cf9.svg";
export { ForwardRef as ReactComponent };